import { PROTECTED_PATHS } from "../../../../app/constants";
// import dashboard from "../../../../assets/icons/Group 112.svg";
// import visitorsIcon from "../../../../assets/icons/Group 113.svg";
// import MeetingsIcon from "../../../../assets/icons/Group 114.svg";
// import notificationsIcon from "../../../../assets/icons/Group 115.svg";
// import staffIcon from "../../../../assets/icons/staff-user.svg";
import { ImStack } from "react-icons/im";
import { MdOutlineDashboard } from "react-icons/md";
import { IoPersonOutline } from "react-icons/io5";
import { BsBell } from "react-icons/bs";
import { RiWaterFlashLine } from "react-icons/ri";
import { BiEnvelope } from "react-icons/bi";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { USER_TYPES } from "../../../../utils/userRole";

const {
  DASHBOARD,
  VTU,
  VTU_TRANSACTIONS_HISTORY,
  VTU_CUSTOMER_CARE,
  PROFILE,
  MESSAGES,
  // USAGE,
  BUY_WATER,
  NOTIFICATION,
  CLEAR_TAMPER,
  PAYMENT_RECORDS,
  FAQ,
} = PROTECTED_PATHS;

export const ESTATE_NAV_ITEMS = [
  {
    title: "Dashboard",
    to: DASHBOARD,
    icon: MdOutlineDashboard,
  },
  {
    title: "VTU",
    to: VTU,
    icon: RiWaterFlashLine,
    children: [
      {
        title: "Transactions History",
        to: VTU_TRANSACTIONS_HISTORY,
      },
      {
        title: "Customer Care",
        to: VTU_CUSTOMER_CARE,
      },
    ],
  },
  {
    title: "Buy Water",
    to: BUY_WATER,
    icon: RiWaterFlashLine,
  },
  {
    title: "Payment Records",
    to: PAYMENT_RECORDS,
    icon: RiWaterFlashLine,
  },
  // {
  //   title: "Usage",
  //   to: USAGE,
  //   icon: ImStack,
  // },
  {
    title: "Clear Tamper",
    to: CLEAR_TAMPER,
    icon: ImStack,
  },
  {
    title: "Profile",
    to: PROFILE,
    icon: IoPersonOutline,
  },

  {
    title: "Message",
    to: MESSAGES,
    icon: BiEnvelope,
  },
  {
    title: "Notification",
    to: NOTIFICATION,
    icon: BsBell,
  },
  {
    title: "FAQ",
    to: FAQ,
    icon: AiOutlineQuestionCircle,
  },
];

export const GENERAL_NAV_ITEMS = [
  {
    title: "Dashboard",
    to: DASHBOARD,
    icon: MdOutlineDashboard,
  },
  {
    title: "VTU",
    to: VTU,
    icon: RiWaterFlashLine,
    children: [
      {
        title: "Transactions History",
        to: VTU_TRANSACTIONS_HISTORY,
      },
      {
        title: "Customer Care",
        to: VTU_CUSTOMER_CARE,
      },
    ],
  },
];

export const NAV_ITEMS_BY_ROLE = {
  [USER_TYPES.ESTATE_MEMBER]: ESTATE_NAV_ITEMS,
  [USER_TYPES.VTU_USER]: GENERAL_NAV_ITEMS,
};
